import OrganisationValidator from './OrganisationValidator';

export default OrganisationValidator;
